import { jsx as _jsx } from "react/jsx-runtime";
import { Tooltip, Button } from 'antd';
import { MinusOutlined } from '@ant-design/icons';
import { useI18n } from 'applib-frontend';
const SHORT_LENGTHS = ['00:01:00', '00:02:00', '00:03:00', '00:04:00', '00:05:00'];
const isLengthShort = (length) => SHORT_LENGTHS.includes(length);
const TableSubtractTime = ({ state, length, id, onSubtractTime, }) => {
    const { intl } = useI18n();
    if (state === 'SUCCESS') {
        return (_jsx("span", { children: _jsx(Tooltip, { title: intl.formatMessage({ id: 'taskComplete' }), color: "  #999", trigger: ['click', 'hover'], children: _jsx(Button, { shape: "circle", icon: _jsx(MinusOutlined, {}), size: "small", className: "btn-time-inactive" }) }) }));
    }
    if (state === 'FAILED') {
        return (_jsx("span", { children: _jsx(Tooltip, { title: intl.formatMessage({ id: 'failed_task' }), color: "  #999", trigger: ['click', 'hover'], children: _jsx(Button, { shape: "circle", icon: _jsx(MinusOutlined, {}), size: "small", className: "btn-time-inactive" }) }) }));
    }
    if (isLengthShort(length)) {
        return (_jsx("span", { children: _jsx(Tooltip, { title: intl.formatMessage({ id: 'taskMinimumLength' }), color: "  #999", trigger: ['click', 'hover'], children: _jsx(Button, { shape: "circle", icon: _jsx(MinusOutlined, {}), size: "small", className: "btn-time-inactive" }) }) }));
    }
    return (_jsx(Tooltip, { title: intl.formatMessage({ id: 'minusMinutes' }), color: " #f3ab58", children: _jsx(Button, { onClick: () => onSubtractTime(false, id), shape: "circle", icon: _jsx(MinusOutlined, {}), size: "small" }) }));
};
export default TableSubtractTime;
